<script setup>
    import Formatters from '@/common/plugins/formatters'
    import { useLookupStore } from '@/common/lookups/lookupstore'

    const router = useRouter();
    const lookups = useLookupStore();

    function goToIssue(id) {
        router.push(`/iss/issues/${id}`);
    }
</script>

<template>
    <page>
        <pageHeader title="Dashboard" />

        <div g-2-2>
            <pageSection title="New Customer Issues">
                <dataSet ds="ISS.Issues"
                         sort="CustomerActivityOn"
                         sort-dir="DESC"
                         :page-size="10"
                         :search="{ NewCustomerIssues: true }">
                    <template #empty>
                        <div italic>No new customer issues.</div>
                    </template>
                    <template #result="{r}">
                        <a class="dash-issue" @click="goToIssue(r.IssueId)">
                            <q-icon :name="lookups.GetProperty('IssueType', r.IssueTypeId, 'Icon')"
                                    :style="{ color: lookups.GetProperty('IssueType', r.IssueTypeId, 'Color') }" />
                            <div class="dash-issue-body">
                                <div class="dash-issue-title">{{ r.Title }}</div>
                                <div class="dash-issue-meta">
                                    #{{ r.IssueId }}
                                    <span v-if="r.Customer"> · {{ r.Customer.Name }}</span>
                                    <span v-if="r.SubmittedBy"> · {{ r.SubmittedBy }}</span>
                                    · {{ Formatters.DateTime(r.CustomerActivityOn) }}
                                </div>
                            </div>
                        </a>
                    </template>
                </dataSet>
            </pageSection>

            <pageSection title="Issues with New Comments">
                <dataSet ds="ISS.Issues"
                         sort="CustomerActivityOn"
                         sort-dir="DESC"
                         :page-size="10"
                         :search="{ NewCustomerComments: true }">
                    <template #empty>
                        <div italic>No issues awaiting a response.</div>
                    </template>
                    <template #result="{r}">
                        <a class="dash-issue" @click="goToIssue(r.IssueId)">
                            <q-icon :name="lookups.GetProperty('IssueType', r.IssueTypeId, 'Icon')"
                                    :style="{ color: lookups.GetProperty('IssueType', r.IssueTypeId, 'Color') }" />
                            <div class="dash-issue-body">
                                <div class="dash-issue-title">{{ r.Title }}</div>
                                <div class="dash-issue-meta">
                                    #{{ r.IssueId }}
                                    <span v-if="r.Customer"> · {{ r.Customer.Name }}</span>
                                    · new comment {{ Formatters.DateTime(r.CustomerActivityOn) }}
                                </div>
                            </div>
                        </a>
                    </template>
                </dataSet>
            </pageSection>
        </div>
    </page>
</template>

<style scoped lang="scss">
    .dash-issue {
        display: flex;
        gap: .5rem;
        align-items: flex-start;
        padding: .4rem .25rem;
        border-bottom: 1px solid #eee;
        cursor: pointer;

        &:hover {
            background: #f5f7fa;
        }

        .dash-issue-body {
            flex: 1;

            .dash-issue-title {
                font-weight: 500;
            }

            .dash-issue-meta {
                font-size: .75rem;
                color: #666;
            }
        }
    }
</style>
